import { render, staticRenderFns } from "./RaidersGoodsWindow.vue?vue&type=template&id=2ca3e3a9&"
import script from "./RaidersGoodsWindow.vue?vue&type=script&lang=js&"
export * from "./RaidersGoodsWindow.vue?vue&type=script&lang=js&"
import style0 from "./RaidersGoodsWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports